import _ from "lodash";
import { uuid } from "@sportal/lib";

export const addItemsToList = (items = [], list = { keys: [], list: {} }) => {
  const itemsWithId = _.map(items, (item) => _.extend({ id: uuid() }, item));

  return {
    keys: _.uniq([...list.keys, ..._.map(itemsWithId, "id")]),
    list: { ...list.list, ..._.keyBy(itemsWithId, "id") },
  };
};
export const changeItemInList = (item, list) => ({
  keys: list.keys,
  list: { ...list.list, [item.id]: item },
});

export const removeItemsFromList = (itemIds = [], list) => ({
  keys: _.without(list.keys, ...itemIds),
  list: _.omit(list.list, itemIds),
});

export const getRemovedItems = ({ saved, changed }) =>
  _.values(_.pick(saved.list, _.difference(saved.keys, changed.keys)));
